<script lang="ts">
  import type { Article } from "$lib/types/article";
  import type { Question } from "$lib/types/shared";
  import MetaData from "$lib/MetaData.svelte";
  import ArticleHeader from "$lib/ArticleHeader.svelte";
  import ArticlePage from "$lib/PostPage.svelte";
  import type { PageData } from "./$types";
  import Faq from "$lib/FAQ.svelte";

  type ArticleSlugPage = Article & {
    faq?: {
      heading: string;
      items: Question[];
    };
  };

  let { data }: { data: PageData } = $props();
  // let newArticleData: unknown;
  // const q = useQuery(data?.sanity);
  // $: ({ data: newArticleData } = $q);
  // $: article = newArticleData as ArticlePage;
  let article: ArticleSlugPage = $derived(data?.sanity?.options?.initial?.data);
</script>

<!-- TODO: handle recommended description length, meta image, keywords/tags -->
{#if data?.image}
  <MetaData
    data={{
      title: article?.title,
      description: article?.lead,
      image: data?.image,
      imageAlt: data?.imageAlt,
      imageWidth: data?.imageWidth,
      imageHeight: data?.imageHeight,
      type: "article",
      datePublished: article?.publishedAt,
      author: article?.author,
    }}
    jsonLd={true}
  />
{/if}

{#if article?.content}
  <ArticlePage content={article.content} center>
    <!-- {#if data?.heroImage} -->
    <ArticleHeader
      title={article?.title}
      lead={article?.lead}
      author={article?.author}
      publishedAt={article?.publishedAt}
      image={data?.heroImage ? data.heroImage : undefined}
    />
    <!-- {/if} -->

    {#snippet below()}
      <section class="max-w-prose mx-a">
        {#if article?.faq}
          <h2>{article.faq.heading || `Spørsmål og svar`}</h2>
          <div class="border-solid border-3 rounded-2xl p-2">
            {#each article.faq.items as question (question)}
              <Faq answer={question} />
            {/each}
          </div>
        {/if}
      </section>
    {/snippet}
  </ArticlePage>
{/if}
